window.Email = {
	
	addAttachement: function(data) {	
		if (data.success){
			$('#email_attachement, #email_attachment').tokenInput("add", {id:data.file_infos.file_id , name:data.file_infos.file_fullname});		
			$('.qq-upload-list').css({'max-width' : "300px"});
		} else {
			if (data.file_infos !== undefined && data.file_infos.file_id !== undefined){
				$('#email_attachement, #email_attachment').tokenInput("add", {id:data.file_infos.file_id , name:data.name});
				$('.qq-error-message').html("<span class='qq-error-fileadded'>"+Loc.g('Le fichier existe déjà mais a été lié à l’email')+"</div>");
				$('.qq-upload-list').css({'max-width' : "450px"});
			}
		}
	},
	
	sendMandateInvite: function(docId, docType, template) {
		window.EventBus.emit('sendMandateInvite', {docId, docType, template});
	},

	sendProposal: function() {
        window.EventBus.emit('email:sendDocument');
	},
	
	sendDoc: function(docType, docId, emailId, emailTemplate){
		var options = {
			dialogClass : "white",
			title		: Loc.g("Envoi d'un document par email"),
			buttons		: [
                {
                	text 	: Loc.g("Enregistrer"),
                    'class' : 'btn btn-default',
					click 	: function(){ Email.submitEditForm('emailForm', false); }
                },
                {
                	text 	: Loc.g("Envoyer"),
					'class' : 'btn btn-primary',
					click 	: function(){Email.submitEditForm('emailForm', true);}
                }
            ],
			width : MyWindow.medium,
			callback	: function(){Email.prepareDocEmailForm();}
		};

		var datas = {
			action 	: "docEmailForm",
			doctype : docType,
			docid 	: docId
		};
		
		if(emailTemplate != undefined){
			
			datas.emailTemplate = emailTemplate;
			
			switch(emailTemplate){
				case 'reminderMandate':
				case 'stripeSaveCard':
					datas.showPaymentLinks = 'N';
				break;
			}
			
		}
		
		if(emailId != undefined){
			datas.id = emailId;
		}

		MyWindow.load("email", datas, options);
	},
	
	loadPopupCheckingEmail: function ()
	{
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupCheckSendingEmail.props = { mode: 'checking'}
		window.sellsyapp.config.globalProperties.$store.state.popupPanel.popupCheckSendingEmail.display = true
	},

	prepareDocEmailForm: function(){
		var formId = "emailForm";
		var options = {success:function(data){Email.callbackRecord(data);}, dataType:"json"};
		var data = {action: 'sendDocEmail'};
		MyForm.prepare(formId, "email&"+$.param(data), options, true);
		MyFacture.initEvent();
		Email.displaySchedule();
	},
	
	chaseDoc: function(docType, docId){
		var options = {
			title	: Loc.g("Envoi d'une relance"),
			buttons	:[
                {
                	text : Loc.g("Annuler"),
                    'class' : 'btn btn-default',
					click : function(){
                		$(this).dialog("close");
                	}
                },
                {
                	text : Loc.g("Envoyer"),
                    'class' : 'btn btn-primary',
					click : function(){
                		$("#emailForm").submit();
                	}
                },
			],
			callback	: function(){Email.prepareChaseDocForm();},
			width : 700
		};
		
		var template = "";
		switch(docType){
			default :
			case "invoice" : template = 'chaseDoc';break;
			case "estimate" : template = 'chaseDocEstimate'; 
		}
		
		MyWindow.load("email", {action:"docEmailForm", doctype:docType, emailTemplate:template, docid:docId, emailType:"chase"}, options);
	},
	
	prepareChaseDocForm: function(){
		var formId = "emailForm";
		var options = {success:function(data){Email.sendEmail(data);}, dataType:"json"};
		var data = {action: 'sendDocEmail', chase : true};
		MyForm.prepare(formId, "email&"+$.param(data), options, true);
		MyFacture.initEvent();
		Qtip.init();
	},
	
	sendEmail: function(data){
		var formisok = MyForm.processJson(data, "emailForm");
		if("ok"!=data.form.status){
			return false;
		}
		
		MyWindow.close();
		
		if (data.message != "" && data.message != undefined ){
			MyWindow.alert(data.message, {type:'confirm',title: Loc.g('Confirmation')});
		}
		return true;
	},
	
    confirmEmail: function()
    {
        MyWindow.alert(Loc.g('Votre email a bien été envoyé'),{type:'confirm',title: Loc.g('Confirmation')});
    },
	
	createThirdAndLink : function(data, args){
		var formIsOk = MyForm.processJson(data, "createThirdPopup");
		if(formIsOk){
			MyFacture.post("email", {'action':"updateRelated", emailid :args.emailid , linkedtype : 'third', linkedid: 'corporation_'+data.thirdid}, function(datas){Email.affectEmailCallback(datas)}, "json");
			MyWindow.close();
			
		}
	},
	
	// EMAILS CLIENTS
	loadEmailbox : function(ownerid, linkedtype, linkedid){
		var options = {
			title	: Loc.g("Boîte d'envoi"),
			buttons	: [
				{text : Loc.g("Fermer"), click : function(){$(this).dialog("close")}}
			],
			width : 960,
			callback	: function(){Email.initEmailbox();}
		};
		MyWindow.load("email", {action:"emailbox", ownerid : ownerid, linkedid : linkedid, linkedtype : linkedtype}, options);
	},
	
	initEmailbox : function(){
		Listing.init("emailsListing");
		Email.prepareFilterForm();
	},

	emailFormButtons : function() {
		var buttons = [
            {
                text: Loc.g("Annuler"),
                'class': 'btn btn-default',
                click: function () {
                    $(this).dialog('close');
                }
            },
            {
				text: Loc.g("Enregistrer"),
                'class': 'btn btn-default',
				click: function () {
					Email.submitEditForm('emailForm', false);
					if (linkedtype === 'third') {
						Listing.update('emailsListing');
					}
				}
			},
            {
                text: Loc.g("Envoyer"),
                'class': 'btn btn-primary',
                click: function () {
                    Email.submitEditForm('emailForm', true);
                }
            }
        ];
		return buttons;
	},

	edit : function(emailid, linkedtype, linkedid, relatedtype, relatedid, prefilledContactId, prefilledContactType, peopleid, template){
		var eid = emailid != undefined ? emailid : '';
		var prefilledContactId = prefilledContactId != undefined ? prefilledContactId : '';
		peopleid = peopleid != undefined ? peopleid : '';

		var title = (emailid === undefined || emailid === "") ? Loc.g('Nouvel email') : Loc.g('Modification email');
		var nylas = '';

		var options = {

			title		: Loc.g(title),
			buttons		: Email.emailFormButtons(),
			width		: MyWindow.large,
            dialogClass : "white",
			callback	: function () { 
				Email.prepareEditForm(nylas); 
				Email.addListenerEmailVerified();
			}
		};

		var params = {
			action: "editForm",
			emailid: eid,
			linkedid: linkedid,
			linkedtype: linkedtype,
			relatedid: relatedid,
			relatedtype: relatedtype,
			prefilledContactId: prefilledContactId,
			prefilledContactType: prefilledContactType,
			peopleid: peopleid,
		};

		if (template) {
			params.template = template;
		}

		MyWindow.load("email", params, options);

	},
	
	answer : function(parentid){
		var options = {
			title		: Loc.g("Réponse à un email"),
			buttons		: Email.emailFormButtons(),
			width		: MyWindow.large,
			callback	: function(){Email.prepareEditForm();}
		};
		MyWindow.load("email", {action:"answerEmailForm", type : 'reply', parentid : parentid}, options);
	},
	
	answerAll : function(parentid){
		var options = {
			title	: Loc.g("Réponse à un email"),
			buttons	: Email.emailFormButtons(),
			width : 960,
			callback	: function(){Email.prepareEditForm();}
		};
		MyWindow.load("email", {action:"answerAllEmailForm", type : 'reply', parentid : parentid}, options);
	},
	
	
	transfer : function(parentid){
		var options = {
			title	: Loc.g("Transfert d'email"),
			buttons	: Email.emailFormButtons(),
			width: 1100,
			height: 737,
			callback	: function(){Email.prepareEditForm();}
		};
		MyWindow.load("email", {action:"answerEmailForm", type : 'transfer', parentid : parentid}, options);
	},
	
	
	prepareEditForm : function(nylas){
		var formId = "emailForm";
		var options = {success:function(data){Email.callbackRecord(data);}, dataType:"json"};
		var data = {action: 'recordEmail'};
		MyForm.prepare(formId, "email&"+$.param(data), options, true);
		MyFacture.initEvent();
		Qtip.init();
		Email.displaySchedule();
	},
	
	submitEditForm : function(form, sendIt){
		if(sendIt === true){
			$('#'+form).find('input[name=email_sendIt]').val('Y');
		}else{
			$('#'+form).find('input[name=email_sendIt]').val('N');
		}
		$('#'+form).submit();
	},
	
	callbackRecord : function(data){
		var formId = "emailForm";
		MyForm.processJson(data, formId);
		if(data.form.status === 'ok') {
			var nylas 	= data.result;

			if(typeof nylas == 'undefined') {
				nylas 	= {};
			}
			if(typeof nylas.type != 'undefined' && nylas.type == 'error') {
				MyWindow.close();
				MyWindow.alert(nylas.message, {type : 'error'});
				return;
			}

			$('#'+formId+' :input').bind('keyup', function(){
				$('#saveButton').val(Loc.g('Enregistrer'));
				$('#'+formId+' :input').unbind('keyup');
				$('#saveButton').attr('onclick', "Email.submitEditForm('emailForm', false)");
				$('#saveButton').css('opacity', '1');
			});
			
			if(data.emailSent == 'Y'){
                MyWindow.close(); 
                window.EventBus.emit('email:sent', {emailId: data.emailID, eventDetails: {provider: 'sendgrid'}})
                Push.success(Loc.g("Email envoyé"));
			}else{
				$('#'+formId).find('input[name=email_id]').val(data.emailID);
				if(data.scheduled == 'Y'){
                    MyWindow.close(); 
                    window.EventBus.emit('email:scheduled', {emailId: data.emailID, eventDetails: {provider: 'sendgrid'}})
					MyWindow.alert(data.message, {type : 'confirm'});
				}
            }
		}
	},
	
	
	prepareFilterForm: function(){
        var options = {success:function(data){Email.processFilterForm(data);}, dataType:"json"};
        MyForm.prepare("emailsFilterForm", "email&action=updateListing", options);
 		Email.initQtip();
    },
	
	processFilterForm: function(data){
		Listing.refresh("emailsListing", data, data.emailsListing_metadatas);
		Email.initQtip();
 	},
	
	prepareFilterForm2: function(){
        var options = {
			success:function(data){
				Email.processFilterForm2(data);
			},
			dataType:"json",
			data : {
				action : 'updateBigListing'
			}
		};
        MyForm.prepare("emailsFilterForm", "email", options);
		Email.initQtip();
    },
	
	processFilterForm2: function(data){
		Listing.refresh("emailsListing", data, data.emailsListing_metadatas);		
		Email.initQtip();
	},
	
	
	buildPagenum: function(pagenum, nbpage){},
	
	loadBox : function(box, step, listName){
		
		var listingName = listName !== undefined ? listName : 'emailsListing';
		var cmd = box+(step !== undefined && step !== '' ? '_'+step : '');

		$('#emailsListing_container').empty();

		$('#mailboxCmd a.'+cmd).addClass('current');
		$('#mailboxCmd a:not(.'+cmd+')').removeClass('current');
		$('#emailsListing_filter_star').val("");
		
		$('#mailBoxes li.'+cmd).addClass('current');
		$('#mailBoxes li:not(.'+cmd+')').removeClass('current');
		
		$('#emailsListing_filter_box').val("");
		
		$('#'+listingName+'_filter_box').val(box);
		if(step !== undefined){
			$('#'+listingName+'_filter_step').val(step);
		}else{
			$('#'+listingName+'_filter_step').val('');
		}
		
		$('.deleteContainer').hide();
		Listing.update(listingName, true);
		
		var filterToHide = $('#emailsListing_filter_stepRead').parent().parent();
		if( box == 'inbox') {
			filterToHide.show();		
		} else {
			filterToHide.hide();	
		}
	},
	
	loadStarBox : function() {
		
		$('#mailBoxes li.star').addClass('current');
		$('#mailBoxes li:not(.star)').removeClass('current');

		$('#emailsListing_filter_step').val("");
		$('#emailsListing_filter_box').val("inbox");
		$('#emailsListing_filter_star').val("Y");
		
		$('.deleteContainer').hide();
		Listing.update('emailsListing', true);
		
		var filterToHide = $('#emailsListing_filter_stepRead').parent().parent();
		filterToHide.hide();
	},
	
	view : function(emailid, context){
		var eid = emailid !== undefined ? emailid : '';
		var context = context !== undefined ? context : 'third';
		
		var options = {
			title	: Loc.g('Email'),
			buttons	: [
				{text : Loc.g("Fermer"), 
				click : function(){
					$(this).dialog("close");
				}}
			],
			width : 1100,
			callback	: function(){
				Email.markAsRead(emailid, context);
			}
		};
		MyWindow.load("email", {action:"view", emailid : eid}, options);
	},
	
	markAsRead : function(emailid, context){
		if($('#email_'+emailid).hasClass('step_unread')){
			$('#email_'+emailid).removeClass('step_unread');
			
            var count       = parseInt($('.unreadCounter').html(),10);
            var nbUnread    = new Big((isNaN(count) ? 1 : count));
			var newUnread   = nbUnread.minus(1);
			
			$('.unreadCounter').html(newUnread.toString());
			
			if(newUnread.toString() === "0"){
				$('.unreadCounter').closest('.unreadCounterContainer').hide();
			}else{
				$('.unreadCounter').closest('.unreadCounterContainer').show();
			}
		} 		
	},
	
	recordMarkAsRead : function(emailid, context){
		MyFacture.post("email", {'action':"markasread", emailid :emailid}, function(data){
			if(data.status == 'ok'){
				if($('#email_'+emailid).hasClass('step_unread')){
					$('#email_'+emailid).removeClass('step_unread');

                    var count       = parseInt($('.unreadCounter').html(),10);
                    var nbUnread    = new Big((isNaN(count) ? 1 : count));
					var newUnread   = nbUnread.minus(1);

					$('.unreadCounter').html(newUnread.toString());

					if(newUnread.toString() === "0"){
						$('.unreadCounter').closest('.unreadCounterContainer').hide();
					}else{
						$('.unreadCounter').closest('.unreadCounterContainer').show();
					}
				} 
			}
		}, "json");
		
	},
	
	markAsUnread : function(emailid, context){
		MyFacture.post("email", {'action':"markasunread", emailid :emailid}, function(data){
			if(data.status == 'ok'){
				if(!$('#email_'+emailid).hasClass('step_unread')){
					$('#email_'+emailid).removeClass('step_read');
					$('#email_'+emailid).addClass('step_unread');

					var count       = parseInt($('.unreadCounter').html(),10);
                    var nbUnread    = new Big((isNaN(count) ? 0 : count));
					var newUnread   = nbUnread.plus(1);
					
					if(newUnread.toString() === "1"){
						$('.unreadCounter').closest('.unreadCounterContainer').show();
					}

					$('.unreadCounter').html(newUnread.toString());
				} 
			}
		}, "json");
	},
	
	affectEmail : function(emailid, linkedtype){
		var linkedid = $('input[name=email_linkedid'+emailid+']').val();
		MyFacture.post("email", {'action':"updateRelated", emailid :emailid , linkedtype : linkedtype, linkedid: linkedid}, function(data){Email.affectEmailCallback(data);}, "json");
	},
	
	affectEmailCallback : function(data){
		if(data.err_code === 0){
			$('#email_'+data.emailid).fadeOut('fast', function(){
				$(this).remove();
				Email.markAsRead(data.emailid, 'bigListing');
			});
		}else{
			MyWindow.alert(data.err_msg, {type: 'error'});			
		}
	},
	
	
	confirmDelete : function(emailid){
		if(Utils.exists("delete-"+emailid)){
			$("#delete-"+emailid).parent().find('.actions').slideUp();
			$("#delete-"+emailid).slideDown();
			MyFacture.customForm("#delete-"+emailid);
		}
	},
	cancelDelete : function(emailid){
		if(Utils.exists("delete-"+emailid)){
			$("#delete-"+emailid).parent().find('.actions').slideDown();
			$("#delete-"+emailid).slideUp();
			MyFacture.customForm("#delete-"+emailid);
		}
	},
	
	
	deleteIt : function(emailid){
		var datas = {'action':"delete", 'emailid':emailid};
		MyFacture.post("email", datas, function(data){Email.deleteItCallback(data);}, "json");
		return true;
	},
			
	deleteItCallback: function(data){
		if(data.emailid !== undefined){
			$('#email_'+data.emailid).fadeOut('fast', function(){
				$(this).remove();
			});

		}
	},
			
	remove : function(emailid, context){
		context = context === undefined ? '' : context;
		
		var message = '', title = '';
		switch(context){
			case 'scheduled' :
				title = Loc.g('suppression email programmé');
				message = Loc.g("Validez pour supprimer la programmation de l'envoi de votre email.");
			default : 
				title = Loc.g("suppression d'email");
				message = Loc.g("Validez pour supprimer l'email");
		}

		var options = {
			resizable	: false,
			noclose		: true,
			title		: title,
			buttons		: [
                {text : Loc.g("Annuler"), click : function(){$(this).dialog("close");}},
                {text :
					Loc.g("Valider"),
					click : function(){
						var datas = {'action':"delete", 'emailid':emailid};
						MyFacture.post("email", datas, function(data){


							$('#email_'+data.emailid).fadeOut('fast', function(){
								var $container = $(this).parent();
								$(this).remove();
								if($container.children().length === 0){
									$('.noEmails').fadeIn('fast');
								}
							});
						}, "json");
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(message, options);
	},
	
	moveToTrash : function(emailid){
		MyFacture.post("email", 
		{'action':"moveToTrash", emailid :emailid}, 
		function(data){
			MyWindow.close();
			Listing.update('emailsListing');
		}, "json");
	},
	
	moveToInbox : function(emailid){
		MyFacture.post("email", 
		{'action':"moveToInbox", emailid :emailid}, 
		function(data){
			MyWindow.close();
			Listing.update('emailsListing');
		}, "json");
	},
	
	
	link : function(emailid){
		var options = {
			title		: Loc.g("Liaison d'email"),
			callback	: function(){},
			width:350
		};
		
		MyWindow.load("email", {action:"askLink", emailid:emailid}, options);
	},
	
	linkToThird : function(emailid, thirdType){
			var title = Loc.g("Attacher à un client");
			switch (thirdType){
				case 'supplier':
					title = Loc.g("Attacher à un fournisseur");
					break;
				case 'prospect':
					title = Loc.g("Attacher à un prospect");
					break;
			}

			var options = {
			title	: title,
			buttons	: [
                {
                    text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click : function(){$(this).dialog("close");}

                },
                {
					text : Loc.g("Lier l'email"),
					'class' : 'btn btn-primary',
					click : function(){$("#emailLinkThirdForm").submit();}
				}
			],
			callback	: function(){Email.prepareLinkThirdForm();},
			width:960
		};
		
		var fileOpt = {action:"thirdLinkForm", emailid : emailid, thirdType:thirdType};
		MyWindow.load("email", fileOpt, options);
	},
	
	
	prepareLinkThirdForm: function(){
		var formId = "emailLinkThirdForm";
		var options = {success:function(data){Email.recordLinkToThird(data);}, dataType:"json"};
		var params = {action:'recordThirdLink'};		
	 	MyForm.prepare(formId, "email&"+$.param(params), options, true);
		MyFacture.customForm();
		DocTools.switchCreateForThird();
	},
	
	recordLinkToThird : function(data){
		var formIsOk = MyForm.processJson(data, "emailLinkThirdForm");
		if(formIsOk){
			MyWindow.close();
		}else{
			
		}
		Listing.update('emailsListing', false);
	},
	
	linkToProspect : function(emailid){
			var options = {
			title	: Loc.g("Attacher à un prospect"),
			buttons	: [
				{
					text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close");}

				},
				{
					text : Loc.g("Lier l'email"), 
					'class' : 'btn btn-primary',
					click : function(){$("#emailLinkProspectForm").submit();}
				}
			],
			callback	: function(){Email.prepareLinkProspectForm();}
		};
		
		var fileOpt = {action:"prospectLinkForm", emailid : emailid};
		MyWindow.load("email", fileOpt, options);
	},
	
	prepareLinkProspectForm: function(){
		var formId = "emailLinkProspectForm";
		var options = {success:function(data){Email.recordLinkToProspect(data);}, dataType:"json"};
		var params = {action:'recordProspectLink'};		
	 	MyForm.prepare(formId, "email&"+$.param(params), options, true);
		MyFacture.customForm();
		
		$('input[name=pp_linkedtype]').change(function(){
			if($(this).val() === "newProspect"){
				$("#newProspectForm").slideDown('fast');
			}else{
				$("#newProspectForm:visible").slideUp('fast');
			}
		});
	},
	
	recordLinkToProspect : function(data){
		var formIsOk = MyForm.processJson(data, "emailLinkProspectForm");
		if(formIsOk){
			MyWindow.close();
		}else{
			
		}
		Listing.update('emailsListing', false);
	},
			
	linkToOpportunity : function(emailid){
		var options = {
		title	: Loc.g("Attacher à une opportunité"),
				buttons	: [
				{
					text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click : function(){$(this).dialog("close"); }

				},
				{
					text : Loc.g("Lier l'email"),
					'class' : 'btn btn-primary',
					click : function(){$("#emailLinkOpportunityForm").submit(); }
				}
				],
				width:800,
				callback	: function(){Email.prepareLinkOpportunitydForm(); }
		};
		var fileOpt = {action:"opportunityLinkForm", emailid : emailid};
		MyWindow.load("email", fileOpt, options);
	},
	
	
	linkToProposal : function(emailid){
		var options = {
			title: Loc.g("Attacher à un document redactor"),
			buttons: [
                {
                    text: Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click: function () {
                        $(this).dialog("close");
                    }

                },
                {
					text: Loc.g("Lier l'email"),
					'class' : 'btn btn-primary',
					click: function () {
						$("#emailLInkProposalForm").submit();
					}
				}
			],
			width: 330,
			callback: function () {
				var formId = "emailLInkProposalForm";
				var options = {
					success: function (data) {
						var formIsOk = MyForm.processJson(data, formId);
						if (formIsOk) {
							MyWindow.close();
						}
						Listing.update('emailsListing', false);
					},
					dataType: "json"
				};
				var params = {action: 'recordProposalLink'};
				
				MyForm.prepare(formId, "email&" + $.param(params), options, true);
				MyFacture.customForm();
			}
		};
		var fileOpt = {action:"proposalLinkForm", emailid : emailid};
		MyWindow.load("email", fileOpt, options);
	},
	
	
	prepareLinkOpportunitydForm: function(){
		var formId	= "emailLinkOpportunityForm";
		var options = {success:function(data){Email.recordLinkToThird(data);}, dataType:"json"};
		var params	= {action:'recordOpportunityLink'};		
	 	MyForm.prepare(formId, "email&"+$.param(params), options, true);
		MyFacture.customForm();
		DocTools.switchCreateForThird();
	},
	
	
	switchCreation : function(type, show){
		switch(type){
			case 'opportunity' : 
				if(show){
					$('#newOpportunity:hidden').slideDown('fast',
					function(){
						Opportunity.initAddForm();
						MyFacture.customForm();
					});
				}else{
					$('#newOpportunity:visible').slideUp('fast');
				}
				break;
			case 'third' :
				break;
		}
	},
	
	displaySchedule : function(){
		if($('#email_scheduled').is(':checked')){
			$('#scheduledDate').show();

			var buttons = [
                {
                	text : Loc.g("Annuler"),
					'class' : 'btn btn-default',
					click : function(){
                		$(this).dialog('close');
                	}
                },
                {
                	text : Loc.g("Enregistrer"),
					'class' : 'btn btn-primary',
					click : function(){
                		Email.submitEditForm('emailForm', false);
                	}
                }
			];

			MyWindow.addOption('buttons', buttons);
			
			MyFacture.customForm();
		} else {
			$('#scheduledDate').hide();

			var buttons = [
                {
                	text : Loc.g("Annuler"),
                    'class' : 'btn btn-default',
					click : function(){
                		$(this).dialog('close');
                	}
                },
                {
                	text : Loc.g("Enregistrer"),
                    'class' : 'btn btn-default',
					click : function(){
                		Email.submitEditForm('emailForm', false);
                	}
                },
                {
                	text : Loc.g("Envoyer"),
                    'class' : 'btn btn-primary',
					click : function(){
                		Email.submitEditForm('emailForm', true);
                	}
                }
			];

			MyWindow.addOption('buttons', buttons);
		}
	},
	
	toggleStar : function(emailid){
		MyFacture.post("email", 
		{'action':"toggleStar", emailid :emailid}, 
		function(data){
			$('#email_'+data.emailid+" .bStar i").toggleClass('fa-star').toggleClass('fa-star-o');
		}
		, "json");
	},
	
	editCustomTemplate : function(etcid){
		var	options = {
				title	: Loc.g("Modification du modèle d'email"),
				buttons	: [
                    {
                        text : Loc.g("Annuler"),
                        click : function() {$(this).dialog("close");}
                    },
                    {
						text : Loc.g("Enregistrer"),
						click : function() {$('#templateForm').submit();}
					},
				],
				width : 850,
				callback : function(data){Email.prepareEditTemplateCustom();}
			};
		
		MyWindow.load("emailPreferences", {action:"emailCustomForm", etcid : etcid}, options );
	},
	
	prepareEditTemplateCustom : function(){
		var formId = "templateForm";
		var options = {success:function(data){Email.recordTemplateCustomCallback(data);}, dataType:"json"};
        MyForm.prepare(formId, "emailPreferences&action=emailCustomRecord", options, true);
		MyFacture.customForm();
	},
	
	recordTemplateCustomCallback : function(data){
		var formIsOk = MyForm.processJson(data, "templateForm");
		if(formIsOk){
            Utils.relocate("./?_f=emailPreferences&action=emailsCustom&etcid="+data.etcid);
		}
	},
			
	deleteCustomTemplate : function(etcid){
		MyFacture.post('emailPreferences', {action:"emailCustomDeletable", etcid : etcid}, function(data) {
			if (typeof data.deletable != 'undefined' && data.deletable) {
				var	options = {
					title	: Loc.g("Suppression du modèle"),
					type : 'warning',
					buttons	: [
						{
							text : Loc.g("Non"),
							click : function() {
								$(this).dialog('close');
							}
						},
						{
							text : Loc.g("Oui"),
							click : function() {
								MyFacture.post('emailPreferences', {action:"emailCustomDelete", etcid : etcid}, function(data){
									Utils.reload();
								});
							}
						},
					]
				};
				MyWindow.alert(Loc.g("Voulez-vous supprimer ce modèle d'email"), options);
			} else {
				var	options = {
					title	: Loc.g("Impossible de supprimer ce modèle")
				}
				MyWindow.alert(Loc.g("Vous ne pouvez pas supprimer ce modèle car il est utilisé."), options);
			}
		});
	},

	copyCustomTemplate: function (etcid) {
        MyFacture.post('emailPreferences', { action: "emailCustomCopy", etcid: etcid }, function (data) {
			Utils.reload();
		});
	},

	injectTemplate : function(){
		var idtpl		= $('select[name=email_template]').val();
		var template	= $('#templateTexts_'+idtpl);

		$('[e_autoattachement]').length > 0 && $('[e_autoattachement]').data('tokenInputObject').clear();

		if(template.length > 0){
			var tpl = {
				subject		: template.find('input.subject').val(),
				message		: template.find('div.message').html(),
				attachments : template.attr('attachment_json') !== undefined ? JSON.parse(template.attr('attachment_json')) : []
			};

			// SUBJECT
			var subject = $("#email_subject");

			if(subject.data('redactor') != undefined){
				subject.redactor("set", tpl.subject);
				subject.redactor("sync");
			} else {
				subject.val(tpl.subject);
			}

			// MESSAGE
			var message = $("#email_message");

			if(message.data('redactor') != undefined){
				message.redactor("set", tpl.message);
				message.redactor("sync");
			}

			// ATTACHMENTS
			if(tpl.attachments.length > 0){
				$.each(tpl.attachments, function(i, item){
					$('[e_autoattachement]').data('tokenInputObject').add(item);
				});
			}

			$('#email-template .comment').css('display', 'block');
		}else{
			$('#email-template .comment').hide();
		}
	},


	prependTemplate : function(){
		var idtpl = $('select[name=email_template]').val();
		if(idtpl !== ""){
			var tpl 			= $('#templateTexts_'+idtpl);
			var subject			= tpl.find('input.subject').val();
			var originalMessage	= $('#email_originalMessage').val();
			var message 		= tpl.find('div.message').html();
			var attachments 	= tpl.attr('attachment_json') !== undefined ? JSON.parse(tpl.attr('attachment_json')) : []

			if(originalMessage.length > 0){
				message = message+originalMessage;	
			}
			
			$("#email_subject").val(subject);
			$("#email_message").redactor("set", '');
			$("#email_message").redactor("insertHtml", message);
			$("#email_message").redactor("sync");
			
            $('#email-template .comment').css('display', 'block');
            
            // ATTACHMENTS
            if(attachments.length > 0){
                $.each(attachments, function(i, item){
                    $('[e_autoattachement]').data('tokenInputObject').add(item);
                });
            }
		}else{
			$('#email-template .comment').hide();
		}
	},
			
	scheduledList : function(relatedtype, relatedid){
		var	options = {
				title	: Loc.g("Emails programmés"),
				buttons	: [
					{
						text : Loc.g("Fermer"),
						click : function() {$(this).dialog("close");}
					}
				],
				width : 900,
				callback : function(data){Email.prepareEditTemplateCustom();}
			};
		
		MyWindow.load("email", {action:"emailScheduledList", relatedtype : relatedtype, relatedid : relatedid}, options);
		
	},
			
	getMoveTo : function(){

		var currentBox = $('#emailsListing_filter_box').val();
		var currentStep = $('#emailsListing_filter_step').val();
		var action = "trash";
		switch (currentBox) {
			case "outbox":
				if (currentStep === "scheduled" || currentStep === "draft"){
					action = "delete";
				} 
				break;
			case "trash":
				action = "delete";
			break;
			}
			
		return action;
	},

	checkMail : function(emailId){
		
		if (emailId === "all") {
			if ($('#mail_all').is(':checked')) {
				$('.emailChecker').attr("checked", true).next().addClass('ui-state-active');
			} else {
				$('.emailChecker').attr('checked', false).next().removeClass('ui-state-active');
			}
		}
		
		var nbChecked = $('.emailChecker:checked').length;
		var moveTo = Email.getMoveTo();
		if (nbChecked !== 0) {
			var msg = "";
			if (moveTo === "trash"){
				msg = Loc.g("Mettre la selection à la corbeille");
			} else {
				msg = Loc.g("Supprimer la sélection");
			}
			
			$('#deleteMailButton span').html(msg);
			$('#groupedActionContainer').fadeIn();
			MyFacture.customForm();
			
			$('#groupedAction option[value=email_massDelete]').html(msg);
		} else {
			$('#groupedActionContainer').fadeOut();
		}
	},
	massDelete : function(){

		var msg =  Loc.g("Supprimer l'ensemble de la selection ?");
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Confirmation"),
			buttons		: [
				{
					text: Loc.g("Non"),
					click : function(){
						$(this).dialog("close");
					}
				},
				{
					text: Loc.g("Oui"),
					click : function(){
						Email.doMassDelete();
						$(this).dialog("close");
					}
				}
			]
		};

		MyWindow.alert(msg, options);
		
	},
	
	doMassDelete: function(){
		var mailSelection = $('.emailChecker:checked').map(function () {
			return $(this).attr('id');
		}).get();
		
		var moveTo = Email.getMoveTo();
		
		var params = {
			action : "massDelete",
			moveTo : moveTo,
			mails : mailSelection
		};
		
		MyFacture.post('email', params, function(){
			Listing.update('emailsListing', true);
		});
		$('.deleteContainer').fadeOut();
				
	},
	
	massStep: function(listingObject, rowSelection, step){
		var params = {
			action : "massStep",
			step : step,
			mails : rowSelection
		};
		
		MyFacture.post('email', params, function(){
			Listing.update('emailsListing', true);
		});
	},
	
	
	
	transformToSupport : function(emailid){

		var msg =  Loc.g("Transformer l'email en ticket support?");
		var options = {
			type		: "warning",
			resizable	: false,
			noclose		: true,
			title		: Loc.g("Confirmation"),
			buttons		: [
				{text: Loc.g("Non"), click : function(){$(this).dialog("close");}},
				{	
					text: Loc.g("Oui"), 
					click : function(){
						var params = {
								action : "transformEmailToTicket",
								emailid : emailid
						};
						MyFacture.post('support_ticket', params, function(data){
							Utils.relocate(data.redirect);
						}, 'json');
					}
				}
			]
		};
		MyWindow.alert(msg, options);
	},
	
	
	initQtip : function(){
		$('[tip_email]').each(function(){
			var emailID = $(this).attr('tip_email');
			$(this).qtip({
				style : {
					classes : 'custom-qtip rich-qtip',
					def		: false
				},
				position: {
					viewport: true,
					my : 'top center',
					at : 'bottom center'
				},
				show : {
					event : 'mouseover'
				},
				hide : {
					event: 'mouseout', 
					fixed: true,
					delay: 100
				},
				content:{
					ajax: {
						url: '/?_f=email', 
						type: 'GET',
						data: {
							action	: 'tipslog', 
							emailid : emailID
						},
						once: true
					}
				}
			});
		});
	},
	
	loadTabMailbox : function(linkedtype, linkedid, relatedtype, relatedid){
		if($('#emails_content').html() == ''){
			var options = {
				action		: "loadTabMailbox",
				linkedtype	: linkedtype,
				linkedid	: linkedid,
				relatedid	: relatedid,
				relatedtype	: relatedtype,
			};

			MyFacture.post('email', options, function (data) {
				$('#emails_content').html(data.listing);
				Listing.init(data.prefix);
				Email.prepareFilterForm();
				MyFacture.customForm('#emails_content');
			}, 'json');
		}
	},
	
	////////////////////
	// blacklist
	viewBlacklist : function() {
		var	options = {
			title	: Loc.g("Blacklist"),
			buttons	: [
                {
                    text	: Loc.g("Annuler"),
					'class' : 'btn btn-default',
                    click	: function() {$(this).dialog("close");}
                },
                {
					text	: Loc.g("Ajouter"),
                    'class' : 'btn btn-primary',
					click	: function() {Email.addBlacklist();}
				}
			],
			width : 900,
			callback : function(data){Email.prepareBlacklistPopup();}
		};
		
		MyWindow.load("email", {action:"viewBlacklist"}, options);
	},
	
	prepareBlacklistPopup : function() {
		MyFacture.customForm();
	},
	
	addBlacklist : function(email) {
		
		var	options = {
			title	: Loc.g("Blacklist - Ajout"),
			buttons	: [
                {
                    text	: Loc.g("Fermer"),
					'class' : 'btn btn-default',
                    click	: function() {$(this).dialog("close");}
                },
                {
					text	: Loc.g("Enregistrer"),
					'class' : 'btn btn-primary',
					click	: function() {$('#addBlacklist').submit();}
				}
			],
			width : 900,
			callback : function(data){Email.prepareAddBlacklistPopup();}
		};
		
		MyWindow.load("email", {action:"addBlacklist", email : email}, options);
	},
	
	prepareAddBlacklistPopup : function() {
		var formId = "addBlacklist";
		var options = {success: function(data){
			var formIsOk = MyForm.processJson(data, "addBlacklist");
			if(formIsOk){
				Email.viewBlacklist();
			}
		}, dataType:"json"};
		var data = {action: 'doAddBlacklist'};
		MyForm.prepare(formId, "email&"+$.param(data), options, true);
		MyFacture.initEvent();
	},
	
	removePopupBlacklist : function(id) {
		var options = {
			resizable	: false,
			noclose		: true,
			title		: Loc.g('Supprimer l\'entrée'),
			type		: 'warning',
			buttons		: [
                {text : Loc.g("Annuler"), click : function(){ $(this).dialog("close"); }},
                {text : Loc.g("Confirmer"), click : function(){	Email.removeBlacklist(id); $(this).dialog("close"); }}
			]
		};

		MyWindow.alert(Loc.g('Voulez-vous vraiment supprimer une entrée de la blacklist ?'), options);
	},
	
	removeBlacklist : function(id) {
		MyFacture.post("email", 
		{
			action		: "doRemoveBlacklist", 
			id			: id
		}, function(datas) {			
			Email.viewBlacklist();
		}, "json");
	},
	
	changeLinkThird : function(emailId) {

		var formId = "changeThirdEmailForm";
		var options = {
			title		: Loc.g('Modifier le client/contact lié'),
			buttons		:
				[
                    {
                        text	: Loc.g("Annuler"),
						'class' : 'btn btn-default',
                        click	: function () {
                            $(this).dialog("close");
                        }
                    },
                    {
						text	: Loc.g("Enregistrer"),
						'class' : 'btn btn-primary',
						click	: function () {
							$("#"+formId).submit();
						}
					}
				],
			width		: 600,
			callback	: function () {
				TokenInput.autoContact($('#email_contact'), 'thirdContact', '', 1, 
					function(item){

						if(item.linkedid !== undefined && item.thirdname !== undefined){
							$("#email_linkedid").tokenInput('add', {id : item.linkedid, name: item.thirdname});
							$("#email_contact").tokenInput('more', 'thirdid_'+item.linkedid);
						}
					}
				);
				
				var options = {
					success		: function (data) {
									var formIsOk = MyForm.processJson( data, formId);
									if(formIsOk){
										Utils.reload();
									}
								  },
					dataType	: "json",
					data		: {
									action		: "recordLinkThirdForm",
									emailId		: emailId
								  }
				};
				
				MyForm.prepare(formId, "email", options, true);
				MyFacture.customForm();
				
				var email_linkedid = $("#email_linkedid").val();
				if(email_linkedid !== '') {
					$("#email_contact").tokenInput('more', 'thirdid_' + email_linkedid);
				}
			}
		};
		
		MyWindow.load("email", {action:"changeLinkThirdEmailForm", emailId: emailId}, options);
	},
	
	bindContactInput : function(item, idelt){
		var more = item.id.replace('corporation_', 'thirdid_');
		$("#"+idelt).tokenInput('more', more); 
	},
	
	bindContactInputTicketByThird : function(more, elemid){
		$("#"+elemid).tokenInput('more', more); 
	},
			
	unbindContactInput : function(idelt){
		$("#"+idelt).tokenInput('more', ''); 
	},

	addListenerEmailVerified: function() {
		EventBus.on("email:onEmailVerified", (event) => {
			const eventData = event.params[0]
			window.sellsyapp.config.globalProperties.$pushToast({
				type: eventData.success ? 'success' : 'error',
				text: eventData.message,
				close: true,
				icon: true,
				unique: true,
				timeout: 4000
			});
			if(eventData.success) {
				document.getElementById('alert-ask-check-email').remove()
				EventBus.off('email:onEmailVerified');
			}
		});
	},
	
	removeListenerEmailVerified: function() {
		EventBus.off('email:onEmailVerified');
	},
	
	redirectToOnboardingEmail : function(){
		window.location.href = '/onboarding/email';
	}
};

window.EmailHelper = {
    openLinkForm: (ids, successCallback) => {
        var options = {
            title    : EmailBoxLinked.translations.titleLink,
            callback: function () {
                EmailBoxLinked.search();
                if ($(EmailBoxLinked.selectors.wrapper).data('haslink') != '1') {
                    $('.btn-red').hide();
                }
                EmailBoxLinked.bindEvents();
                Qtip.init();
            },
            dialogClass: EmailBoxLinked.settings.class,
            width    : 400,
            buttons  : [
                {
                    text : EmailBox.translations.btnCancel,
                    click: function () {
                        $(this).dialog("close");
                    }
                },
                {
                    text  : EmailBox.translations.btnConfirm,
                    id    : 'btn-valid',
                    click: () => {
                        if("" !== $(EmailBoxLinked.selectors.search).val()) {
                            EmailHelper.recordLinkForm(ids).then((res) => { successCallback() })
                        } else {
                            EmailHelper.recordLinkForm(ids)
                        }
                    }
                }
            ]
        };
        MyWindow.load(EmailBox.settings.route, {action: 'confirmLink', ids: ids}, options, undefined, undefined, true);
    },
    recordLinkForm: (ids) => {
        let inputSearch = $(EmailBoxLinked.selectors.search);
        let inputContact = $(EmailBoxLinked.selectors.contact);
        // Get current folder
        let folder = $('.folder input[name="emailBoxListing_filter_folders"]:checked').val();

        if ("" != inputSearch.val()) {
            let linked = inputSearch.val();
            if ('people' == $(EmailBoxLinked.selectors.select).val() && -1 == linked.indexOf('_')) {
                linked = 'people_' + linked;
            }
            let contact = inputContact.val();
            return EmailBoxLinked.link(linked, contact, ids, folder);
        } else {
            EmailBoxLinked.addAndLink($('.add-object input[name=type]:checked').val(), ids, folder);
        }
    },
}
